export const numberRE = /^\s*[+-]?\d*\.?\d+(?:[eE][+-]?\d+)?\s*$/

/**
 * 返回数字的小数位数
 *
 * @param number 指定的数字
 *
 * @returns 数字的小数位数
 */
export function decimalLength(number: number | string) {
  // Get digit length of e
  const eSplit = number.toString().split(/[eE]/)
  const len = (eSplit[0].split('.')[1] || '').length - +(eSplit[1] || 0)

  return len > 0 ? len : 0
}

/**
 * 将给定的实数保留一定的小数
 *
 * @param number 需要处理的实数
 * @param decimal 需要保留的小数
 *
 * @returns 保留小数后的值
 */
export function toFixed(number: number, decimal: number) {
  if (decimal === 0) return Math.round(number)

  let snum = number.toFixed(decimalLength(number))

  const pointPos = snum.indexOf('.')

  if (pointPos === -1) return number

  const nums = snum.replace('.', '').split('')
  const targetPos = pointPos + decimal
  const datum = nums[targetPos]

  if (!datum) return number

  if (snum.charAt(targetPos + 1) === '5') {
    snum = `${snum.slice(0, Math.max(0, targetPos + 1))}6`
  } else {
    snum = snum.slice(0, Math.max(0, targetPos + 2))
  }

  return Number.parseFloat(Number(snum).toFixed(decimal))
}

/**
 * 将给定的数字限定在指定的范围内
 *
 * @param number 需要限定范围的数
 * @param min 边界最小值，包含该值
 * @param max 边界最大值，包含该值
 *
 * @returns 限定在范围内的值
 */
export function boundRange(number: number | string, min: number, max: number) {
  return Math.max(min, Math.min(max, Number.parseFloat(number as string)))
}

/**
 * 在给定的范围内随机一个数
 *
 * @param max 最大值
 * @param min 最小值，默认为 0
 *
 * @returns 生成的随机数
 */
export function random(max: number, min = 0) {
  if (min === max) return min

  if (min > max) {
    ;[min, max] = [max, min]
  }

  return Math.random() * (max - min) + min
}
